export default __webpack_public_path__ + "cardModelNlp-allf4a5fe.png";